import React, { createContext, useState } from 'react';
import { GoogleContextType, IUserGoogleData } from '../../@Types/index';

export const GoogleContext = createContext<GoogleContextType | null>(null);

interface GoogleProviderProps {
    children?: React.ReactNode;
  }

const GoogleProvider: React.FC<GoogleProviderProps> = ({ children }) => {

    const [ userGoogle, setUserGoogle ] = useState<IUserGoogleData>();
    const [ statusGoogle , setStateStatus ] = useState<boolean>(false);
  
    const saveUser = (user: IUserGoogleData) => {
        const newUser: IUserGoogleData = {
            email: user.email,
            familyName: user.familyName,
            givenName: user.givenName,
            googleId: user.googleId,
            imageUrl: user.imageUrl,
            name: user.name,
            url: user.url,
        }
        setUserGoogle(newUser);
        setStateStatus(true);
    }

    const saveStatusGoogle = (status: boolean) => {
        setStateStatus(status);
    }

    return (
        <GoogleContext.Provider value={{statusGoogle, userGoogle, saveUser, saveStatusGoogle}} >
            { children }
        </GoogleContext.Provider>
    )
}

export default GoogleProvider;
